export const maxAmount = {
    OPX: 5000,
    UZS: 99999999,
};


// WEBPACK FOOTER //
// ./js/constants/StakeMaxAmount.js